import { Col, Row, Pagination, Button } from "react-bootstrap";
import "./UsersideTransport.css";
import BackArrow from "../../components/backArrow";
import { images } from "../../constants";
import { useState, useEffect, useMemo } from "react";
import Rating from "@mui/material/Rating";
import Vehicaldetail from "../../components/Vehicaldeatil";
import RatingModel from "../../components/ProductsRating";
import Typography from "@mui/material/Typography";
import ReplyIcon from "@mui/icons-material/Reply";
import GradeIcon from "@mui/icons-material/Grade";
import MessageIcon from "@mui/icons-material/Message";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  usertransportbtn,
  Transportdetail,
} from "../../constants/jsonConstant";
import Modal from "react-bootstrap/Modal";
import Reportbox from "../../components/Reportbox";
import Reportselectezibox from "../../components/Report to selectezi";
import CandidatesBox from "../../components/candidatesBox";
import Qrmodal from "../../components/QRmodal/Qrmodal";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import CallIcon from "@mui/icons-material/Call";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ErrorIcon from "@mui/icons-material/Error";
import ConnectProfileModal from "../../components/Connect_Modal_Buy";
import Suggestionbox from "../../components/Suggestionbox";
import QRCode from "qrcode.react";
import { useSelector } from "react-redux";
import { useGetAllConnectedQuery } from "../../features/connection/connectionApiSlice";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import url from "../../config/axios";
import { getAsset } from "../../helpers/helper";
import { Form, FormControl, Dropdown } from "react-bootstrap";
import Desmodal from "../../components/Des_Modal";
import { useNavigate } from "react-router-dom";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import dummyUser from "../../assets/images/dummy/dummy-user.png";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import PeopleRatingsModal from "../../components/Rating_People";
import RedoIcon from "@mui/icons-material/Redo";
import CampaignIcon from "@mui/icons-material/Campaign";
import ShareIcon from "@mui/icons-material/Share";
import ReportIcon from "@mui/icons-material/Report";
import StarIcon from "@mui/icons-material/Star";
import MassengerModals from "../../components/Navbar/MassengerModal";

const resolveItemImage = (images) => {
  if (!images) return noImagePlaceholder;
  if (Array.isArray(images)) {
    const first = images.flat(Infinity).find((item) => item && String(item).trim());
    if (!first) return noImagePlaceholder;
    return getAsset(first) || noImagePlaceholder;
  }
  if (typeof images === "string" && images.trim()) {
    const src = getAsset(images);
    if (!src || /\/assets\/?$/.test(src)) return noImagePlaceholder;
    return src;
  }
  return noImagePlaceholder;
};

const UserTransport = ({ shopData, itemshow, shopid }) => {
  const [value] = useState(3);
  const [viewmodal, setViewmodal] = useState(0);
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [showpeoplerating, setShowpeoplerating] = useState(false);
  const handleClosepeople = () => setShowpeoplerating(false);
  const handleShowpeople = () => setShowpeoplerating(true);
  const [lgShow, setLgShow] = useState(0);
  const [isloading, setIsloading] = useState(false);
  const [showqr, setShowqr] = useState(0);
  const [smShow, setSmShow] = useState(0);
  const [lgShowreport, setLgShowreport] = useState(false);
  const [selectezireport, setSelectezireport] = useState(false);
  const [showoneModal, setShowoneModal] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [showconnect, setShowconnect] = useState(false);
  const [showtransport, setShowtransport] = useState();
  const [desshow, setDesshow] = useState(0);
  const [showrating, setShowrating] = useState();
  const [des, setDes] = useState();
  const [lgMsgShow, setLgMsgShow] = useState(false);
  const [suggestion, setSuggestion] = useState({
    vendorid: "",
    userid: name._id,
    username: name.fullname,
    useremail: name.email,
    role: "",
    imageUrl: "",
    message: "",
  });

  // Fetch this user's connections (across every shop + general profile they
  // own) so the "Send Connection Request" link reflects the real state for
  // THIS shop — previously it was a static link that always looked the
  // same, even after the request was accepted.
  const { data: connectedDataResponse } = useGetAllConnectedQuery(
    { userid: name?._id },
    { skip: !name?._id, refetchOnMountOrArgChange: true }
  );
  const matchesShop = (list, shopId) =>
    (list || []).some(
      (c) =>
        c.senderid === shopId ||
        c.recieverid === shopId ||
        c.sendershopid === shopId ||
        c.recievershopid === shopId
    );
  const isThisShopRequested = matchesShop(
    connectedDataResponse?.requested,
    shopData?._id
  );

  const closemodal = () => setShowmodal(false);

  useEffect(() => {
    url.get(`user/id?id=${name._id}`).then((res) => {
      setSuggestion((prevState) => ({
        ...prevState,
        imageUrl: res?.data?.data?.User?.imageUrl[0],
        vendorid: shopData?.shopid,
      }));
    });


url
      .get(`rating?type=shop&id=${shopid}`)
      .then((res) => {
        setShowrating(res?.data?.data?.averageRating);
      })
      .catch((error) => {
        console.error("Error fetching rating:", error);
      });

  }, [shopData,shopid]);

  const handleTabSelect = () => {
    setShowoneModal(true);
  };
 
  const handleClosedes = () => {
    setDesshow(0);
  };

  useEffect(() => {
    setShowqr(1);
  }, [setShowqr]);

  const handleCloses = () => {
    setShowoneModal(false);
  };

  const Closeconnect = () => {
    setShowconnect(false);
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const [searchItems] = useState(["1", "2", "3", "4", "5"]);

  const handleFocus = () => {
    setShowDropdown(true);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 100);
  };

  const suggestPost = (e) => {
    setIsloading(true);
    e.preventDefault();
    url
      .post(`/suggestion/`, suggestion)
      .then((res) => {
        SuccessNotify("Suggestion Data is posted successfully");
        setLgShow(0);
        setIsloading(false);
      })
      .catch((err) => {
        setLgShow(0);
        FailedNotify("Failed to post suggestion Data");
      });
  };

  const filterTransport = (e) => {
    
  const brandName = e;
  if (!brandName) {
    setShowtransport(undefined);
    setCurrentPage(1);
    return;
  }
    url
      .get(
        `tranportvehicle/searchbybrandName?brandName=${brandName}&businessType=transportShop`
      )
      .then((res) => {
        setShowtransport(res?.data?.data);
      });
  };

  const suggestHandel = (event) => {
    setSuggestion((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

const [displayedData, setDisplayedData] = useState(
  Array.from({ length: 100 }, (_, i) => ({
    _id: `dummy-${i}`,
    images: dummyezi,
    brandName: `Selectezi ${i + 1}`,
    title: `Transport Item ${i + 1}`,
    description: `Explore with Selectezi item ${i + 1}.`,
  }))
);


 

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  const ownerUserId = useMemo(() => {
    const raw = shopData?.userid;
    if (!raw) return null;
    if (typeof raw === "object") return raw._id || raw.id || null;
    return raw;
  }, [shopData?.userid]);

  const initialUserForChat = useMemo(() => {
    if (!ownerUserId) return null;
    const img = Array.isArray(shopData?.image)
      ? shopData.image.find((i) => i && String(i).trim())
      : shopData?.image || null;
    return {
      _id: ownerUserId,
      fullname: shopData?.shopname || "Transport Shop",
      image: img,
    };
  }, [ownerUserId, shopData?.shopname, shopData?.image]);

  const handleOpenMessage = () => {
    if (!initialUserForChat?._id) {
      FailedNotify("User not found");
      return;
    }
    if (name?._id && String(name._id) === String(initialUserForChat._id)) {
      FailedNotify("You cannot message yourself");
      return;
    }
    setLgMsgShow(true);
  };

  const handleViewConsultancy = () => {
    const resolvedShopId = shopData?._id || shopid;
    if (!resolvedShopId || !ownerUserId) {
      FailedNotify("Unable to open consultancy services");
      return;
    }
    navigate(
      `/view-consultancy-services-profile/${resolvedShopId}/${ownerUserId}`,
    );
  };

  return (
    <>
      <MassengerModals
        lgMsgShow={lgMsgShow}
        setLgMsgShow={setLgMsgShow}
        initialUser={initialUserForChat}
        onInitialUserConsumed={() => {}}
      />
      <Desmodal desshow={desshow} handleClosedes={handleClosedes} des={des} />
      <Suggestionbox
        lgShow={lgShow}
        setLgShow={setLgShow}
        suggestPost={suggestPost}
        suggestHandel={suggestHandel}
      />
      <PeopleRatingsModal
        show={showpeoplerating}
        handleClosepeople={handleClosepeople}
      />

      <Reportbox
        lgshowreport={lgShowreport}
        setLgShowreport={setLgShowreport}
        shopid={shopid}
      />
      <Reportselectezibox 
        selectezireport={selectezireport}
        setSelectezireport={setSelectezireport}
        shopid={shopid}
      />
      <RatingModel smShow={smShow} setSmShow={setSmShow} shopid={shopid} />

      <Col
        lg="11 mx-auto shop-profile-box ps-5 pe-5 pt-2 pb-2 transport-shop-profile"
        style={{ backgroundColor: "#fafafa" }}
      >
        <Row className="mb-3">
          <Col>
            <BackArrow />
          </Col>
          <Col className="text-end">
            <button
              onClick={() => {
                navigator.clipboard.writeText(window.location.href);
                SuccessNotify("Link copied to clipboard!");
              }}
              className="text-white bg-blue  rounded mt-2 pt-1 pb-1 ps-4 pe-4"
              style={{
                backgroundColor: "#0353a4",
                border: "none",
                fontSize: "11px",
              }}
            >
              Share <RedoIcon className="share_icon_f" />
            </button>
          </Col>
        </Row>

        {/* Profile Header */}
        <Row className="profile-header transport-shop-header align-items-start bg-white p-4 rounded">
          <Col xs={12} md={2} className="text-center transport-shop-avatar">
            <img
              src={shopData?.image ? getAsset(shopData?.image) : dummyUser}
              alt={shopData?.shopname || "Shop Profile"}
              className="profile-photo rounded-circle mb-3"
              crossOrigin="anonymous"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = dummyUser;
              }}
            />
          </Col>
          <Col xs={12} md={10} className="transport-shop-header-content">
            <Row className="transport-shop-header-layout">
              <Col md={8} className="transport-shop-summary">
                <h4 className="mb-0">{shopData?.shopname}</h4>
                <p className="text-muted mb-0">
                  {" "}
                  <b>Profile ID :</b>
                  {shopData?.shopid ? btoa(shopData.shopid) : ""}
                </p>
                <p className="text-muted mb-0">{shopData?.shopaddress}</p>

                <div className="d-flex align-items-center mb-2">
                  <div className="d-flex align-items-center transport-shop-rating">
                   {showrating !== undefined &&
                   showrating !== null &&
                   showrating !== "" ? (
                      <>
                          <p className="marginset d-flex align-items-center mb-0">
                        <GradeIcon
                          fontSize="small"
                          style={{ marginTop: "1px" }}
                        />
                        <b>{showrating}</b>
                      </p>
                      <button className="transport-view-rating text-white rounded border-0 font_11" style={{backgroundColor:"#0353a4"}} onClick={handleShowpeople}>View Rating</button>
                      </>
                  
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
              <Col
                md={4}
                className="text-end d-flex flex-column justify-content-start transport-shop-contact"
              >
                <Col lg="2" className="mt-3 mb-2 ms-auto transport-shop-qr">
                  {showqr == 1 && (
                    <QRCode
                      size={128}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={`https://selectezi.com/${shopid ? btoa(shopid) : ""}`}
                      viewBox={`0 0 256 256`}
                    />
                  )}
                </Col>

                <Row className="transport-shop-call-buttons">
                  <Col lg="6">
                    <Button
                      variant="primary "
                      className="w-100 mb-2 pt-1 pb-1"
                      onClick={handleOpenMessage}
                    >
                      <ChatBubbleIcon fontSize="small" /> Message
                    </Button>
                  </Col>

                  <Col lg="6">
                    <Button
                      variant="primary "
                      className=" w-100 mb-2 pt-1 pb-1"
                    >
                      <CallIcon fontSize="small" />
                      Call
                    </Button>
                  </Col>
                </Row>

                <Button variant="primary" onClick={handleViewConsultancy}>
                  View Consultancy Services
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Tabs */}
        <Row className="tabs-row transport-shop-actions bg-white p-3 rounded mt-3 justify-content-between">
          <Col lg="2" xs="auto" className="me-4">
            <span
              role="button"
              className="font_13 transport-shop-action-link"
              onClick={() => setSmShow(true)}
            >
              
              <StarIcon style={{ color: "#ffc107" }} /> Rate this Shop
            </span>
          </Col>
          <Col lg="2" xs="auto" className="me-4 p-0">
            {/* No "Connected" state here on purpose — once accepted, this
                should keep behaving like a normal, clickable connect
                action instead of locking into a static "Connected" label. */}
            <span
              role="button"
              className="font_13 transport-shop-action-link"
              style={
                isThisShopRequested
                  ? { color: "#856404", cursor: "default" }
                  : undefined
              }
              onClick={() => setShowconnect(true)}
            >
              <ShareIcon
                style={{
                  color: isThisShopRequested ? "#ffc107" : "#0353a4",
                }}
              />{" "}
              {isThisShopRequested ? "Request Sent" : "Send Connection Request"}
            </span>
          </Col>
          <Col lg="2" xs="auto" className="me-4">
            <span
              role="button"
              className="font_13 transport-shop-action-link"
              onClick={() => setLgShow(true)}
            >
              <CampaignIcon style={{ color: "green" }} /> Suggestion to Owner
            </span>
          </Col>
          <Col lg="2" xs="auto">
            <span
              role="button"
              className="font_13 transport-shop-action-link"
              onClick={() => setLgShowreport(true)}
            >
              <ReportProblemIcon style={{ color: "orange" }} /> Report to Owner
            </span>
          </Col>

          <Col lg="2" xs="auto">
            <span
              role="button"
              className="font_13 transport-shop-action-link"
              onClick={() => setSelectezireport(true)}
            >
              <ReportIcon style={{ color: "red" }} /> Report to Selectezi
            </span>
          </Col>
        </Row>

<div className="main_relativdiv position-relative mt-3 transport-items-section">
  <div className="position-absolute search-absolute transport-shop-search">
    <Form
      className="position-relative"
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <FormControl
        type="text"
        placeholder="Search"
        className="mr-sm-2 search-buing-area"
        name="brandName"
        onChange={(e) => filterTransport(e.target.value)}
      />
    </Form>
  </div>
  <Row className="transport-items-tabs-row">
    <Tabs defaultActiveKey="service" className="service_TAB ms-3">
      <Tab eventKey="service" title="Services" className="p-0">
        <Col lg="12 mt-3">
          <div className="t-scroll noscroll">
            <Row className="m-1">
              {(() => {
                // ✅ CORRECT DATA LOGIC
                let data =
                  showtransport && showtransport.length > 0
                    ? showtransport
                    : Array.isArray(itemshow) && itemshow.length > 0
                    ? itemshow
                    : displayedData;

                const indexOfLastItem = currentPage * itemsPerPage;
                const indexOfFirstItem = indexOfLastItem - itemsPerPage;
                const currentItems = data.slice(
                  indexOfFirstItem,
                  indexOfLastItem
                );

                return currentItems.map((e) => {
                  const isDummy = String(e?._id).startsWith("dummy");
                  const itemImage = isDummy
                    ? dummyezi
                    : resolveItemImage(e?.images);

                  return (
                    <Row
                      key={e?._id}
                      className="bg-white rounded m-1 p-2 mt-2 card-row transport-item-card"
                      style={{
                        boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
                        minHeight: "150px",
                        alignItems: "center",
                      }}
                    >
                      <Col xs={12} lg="4" className="mb-1 transport-item-image-col">
                        <div className="img_fixxx transport-item-image">
                          <img
                            src={itemImage}
                            alt={e?.brandName || "Transport item"}
                            className="transport_imgggg_buying"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            crossOrigin={
                              isDummy || itemImage === noImagePlaceholder
                                ? undefined
                                : "anonymous"
                            }
                            onError={(ev) => {
                              ev.target.onerror = null;
                              ev.target.src = noImagePlaceholder;
                            }}
                          />
                        </div>
                      </Col>

                      <Col
                        xs={12}
                        lg="8"
                        className="mt-2 d-flex flex-column justify-content-center transport-item-details"
                      >
                        <Row className="mt-2">
                          <Col xs={6} lg="4">
                            <h4 className="font-bold">{e?.brandName}</h4>
                          </Col>
                          <Col xs={6} lg="4">
                            <h5>{e?.title}</h5>
                          </Col>

                          <Col
                            xs={12}
                            lg="6"
                            xl="4"
                            className="loop_starset d-flex align-items-center mb-2"
                          >
                            <Typography component="legend">Rating</Typography>
                            <Rating name="read-only" value={value} readOnly />
                          </Col>
                        </Row>

                        <Row className="mt-2 flex-grow-1">
                          <Col xs={12} lg="6" xl="8">
                            <p className="mb-0">
                              <b>Description</b>
                            </p>
                            <p className="font-grey font-sm">
                              {e?.description}
                              {e?.description?.length > 20 && (
                                <span
                                  onClick={() => {
                                    setDesshow(e?._id);
                                    setDes(e?.description);
                                  }}
                                  className="mb-0 cursor_P font_11 text-dark"
                                  style={{ marginTop: "3px" }}
                                >
                                  &nbsp;<b>ReadMore...</b>
                                </span>
                              )}
                            </p>
                          </Col>

                          <Col xs={12} lg="12">
                            <button
                              className="viewshopnew"
                              disabled={isDummy || !e?._id || !shopid}
                              onClick={() => {
                                if (isDummy || !e?._id || !shopid) {
                                  FailedNotify("Unable to open this vehicle");
                                  return;
                                }
                                navigate(
                                  `/buy-vehicle-detail/${e._id}/${shopid}`,
                                );
                              }}
                            >
                              View
                            </button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  );
                });
              })()}
            </Row>
          </div>

          {/* ✅ PAGINATION — SAME DATA SOURCE */}
          <div className="pagination d-flex justify-content-center mt-3">
            <Pagination>
              {(() => {
                let data =
                  showtransport && showtransport.length > 0
                    ? showtransport
                    : Array.isArray(itemshow) && itemshow.length > 0
                    ? itemshow
                    : displayedData;

                const pageCount = Math.ceil(data.length / itemsPerPage);

                return Array.from({ length: pageCount }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ));
              })()}
            </Pagination>
          </div>
        </Col>
      </Tab>
    </Tabs>
  </Row>

</div>

        <ConnectProfileModal
          connectbuyModal={showconnect}
          setConnectbuyModal={setShowconnect}
          shopData={shopData}
        />
      </Col>
    </>
  );
};

export default UserTransport;
